module.exports = __webpack_public_path__ + "static/media/home-banner-img.93a352b5.png";